(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[166],{

/***/ 9770:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course",
      function () {
        return __webpack_require__(1909);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CardImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2125);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7966);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;  \n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 1.8rem 2rem;\n  border-radius: 20px;\n  background: ",
        ";\n  text-decoration: none;\n  color: inherit;\n\n  > *:last-child {\n    margin-top: auto;\n  }\n\n  @media ( max-width: 350px ) {\n    padding: 1rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n\n    > a {\n      flex-grow: 1;\n      ",
        "\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      height: 150px;\n\n      img {\n        max-height: 100%;\n        width: auto;\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      flex-grow: 1;\n      min-height: 150px;\n      max-width: 150px;\n\n      img {\n        max-width: 100%;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    h3 {\n      max-width: 27rem;\n      margin: 1.5rem 0 0.5rem;\n      ",
        "\n      font-size: ",
        ";\n      line-height: 1.15;\n    }\n    \n    p {\n      max-width: 27rem;\n      margin: 0 0 1rem;\n      ",
        "\n      font-size: ",
        ";\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    h3 {\n      max-width: 27rem;\n      margin: 0 0 1.5rem;\n      ",
        "\n      font-size: ",
        ";\n    }\n    \n    p {\n      max-width: 27rem;\n      margin: 0;\n      ",
        "\n      font-size: ",
        ";\n    }\n\n    > a {\n      transition:\n        background .3s ease-out,\n        color .3s ease-out;\n      \n      img {\n        filter: invert( 0 );\n        transition: filter .3s ease-out;\n      }\n\n      &:hover {\n        background: ",
        ";\n        color: ",
        ";\n\n        img {\n          filter: invert( 0.9 );\n        }\n      }\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        " {\n    ",
        "\n    \n    ",
        "\n  }\n\n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



function Card(param) {
    var _href = param.href, href = _href === void 0 ? null : _href, _large = param.large, large = _large === void 0 ? false : _large, children = param.children;
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCard, {
            $large: large,
            $asLink: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                href: href,
                children: children
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCard, {
        $large: large,
        children: children
    });
}
var CardImage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d22a2665-0"
})(_templateObject());
var cardWrapStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), function(p) {
    return p.theme.colors.orange;
});
var StyledCard = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d22a2665-1"
})(_templateObject7(), function(p) {
    return !p.$asLink && cardWrapStyles;
}, function(p) {
    return p.$asLink && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), cardWrapStyles);
}, CardImage, function(p) {
    return p.$large && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3());
}, function(p) {
    return !p.$large && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4());
}, function(p) {
    return p.$large && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), p.theme.typo.sentientMedium, p.theme.typo.sizes.large, p.theme.typo.sentientLight, p.theme.typo.sizes.medium);
}, function(p) {
    return !p.$large && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), p.theme.typo.sentientLight, p.theme.typo.sizes.bumped, p.theme.typo.sentientMedium, p.theme.typo.sizes.bumped, p.theme.colors.black, p.theme.colors.ivory);
});
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 1909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ course; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/AppChrome.tsx + 22 modules
var AppChrome = __webpack_require__(5368);
// EXTERNAL MODULE: ./components/Hero.tsx
var Hero = __webpack_require__(1547);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/Card.tsx
var Card = __webpack_require__(6050);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(9851);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(5076);
// EXTERNAL MODULE: ./components/Image.tsx
var Image = __webpack_require__(5988);
;// CONCATENATED MODULE: ./components/CourseSessions.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  margin: calc( var( --grid-gutter ) / -2 );\n\n  > * {\n    margin: calc( var( --grid-gutter ) / 2 );\n  }\n\n  @media ( min-width: 650px ) {\n    grid-template-columns: repeat( 3, 1fr );\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function CourseSessions(param) {
    var sessions = param.sessions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        $bottom: 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid, {
                children: sessions.map(function(session, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                        href: "/course/".concat(session.slug),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Session ",
                                    intToWords(i)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: session.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* CardImage */.x, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: session.sessionIcon[0].url,
                                    alt: session.sessionIcon[0].alt,
                                    width: session.sessionIcon[0].width,
                                    height: session.sessionIcon[0].height,
                                    dateModified: session.sessionIcon[0].dateModified,
                                    layout: "fill",
                                    objectFit: "contain",
                                    sizes: "150px"
                                })
                            })
                        ]
                    }, session.id);
                })
            })
        })
    });
}
function intToWords(int) {
    var ones = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fouteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
        "twenty", 
    ];
    return ones[int] || "".concat(int);
}
var StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a033e1f8-0"
})(_templateObject());
/* harmony default export */ var components_CourseSessions = (CourseSessions);

;// CONCATENATED MODULE: ./pages/course/index.tsx




function CoursePage(param) {
    var course = param.entry, courseSessions = param.courseSessions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppChrome/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: course.title
                    }),
                    course.pageIntro
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CourseSessions, {
                sessions: courseSessions
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var course = (CoursePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9770); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);